import CryptoJS from "crypto-js";

const encrypt = process.env.REACT_APP_DECRYPTOR;
const encryptionKeyHex = process.env.REACT_APP_ENCRYPTION_KEY;
const encryptionKey = CryptoJS.enc.Hex.parse(encryptionKeyHex);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

export const decryptIfEncrypted = (value) => {
  try {
    if (encrypt === "false") return value;
    if (typeof value !== "string") return value;

    if (value.startsWith("ENC::")) {
      const encryptedBase64 = value.replace("ENC::", "");
      const bytes = CryptoJS.AES.decrypt(encryptedBase64, encryptionKey, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return bytes.toString(CryptoJS.enc.Utf8) || value;
    }

    return value;
  } catch (error) {
    console.error("Erro ao descriptografar campo:", error, value);
    return value;
  }
};
